export let unsubscribeAsk = "UNLQBd";
export let suggestedUnsubscribeReason = "MYBrq";
export let deleteAllCheckboxLabel = "HNwxwd";
export let noThankYou = "Ywxgjc";
export default {unsubscribeAsk,suggestedUnsubscribeReason,deleteAllCheckboxLabel,noThankYou};